@if (!(loadingTotalPrice$|async) && !(loadingTotalQuantity$|async)) {
  <div>
    @if (!isMiniCart) {
      <!-- summary -->
      <div class="border-bottom-1">
        <p class="" translate>
          {{'sub_total_' + labelSuffix}}
          <span class="pull-right">
            <span>{{data?.TotalPriceBeforeDiscount|currency:data?.SessionCurrency:'symbol'}}</span>
          </span>
        </p>
        @if (!removeDelivery) {
          <p class="{{'delivery-' + labelSuffix}}" translate>
            {{'delivery_' + labelSuffix}}
            @if (data?.DeliveryDays>0) {
              <span
                [translateParams]="{X: data?.DeliveryDays}"
                translate>Within X business days
              </span>
            }
            <span class="pull-right">{{data?.DeliveryPrice |currency:data?.SessionCurrency:'symbol'}}</span>
          </p>
        }
        @if (data?.Vat) {
          <p class="" translate>
            {{'calculated_vat_' + labelSuffix}}
            <span class="pull-right">{{data?.Vat |currency:data?.SessionCurrency:'symbol'}}</span>
          </p>
        }
      </div>
      <!-- /summary -->
      <!-- coupon -->
      @if (showCoupon) {
        <div class="">
          <cart-coupon (updateTotalPrice)="updateTotalPrice()" [useOneCoupon]="useOneCoupon"></cart-coupon>
        </div>
      }
      <!-- total prices -->
      <h5 class="fw-bold app-primary-text  border-top-1 mb-0 pt-3">
        <span class="" translate>
          {{'total_' + labelSuffix}}
        </span>
        <span class="pull-right">
          {{data?.TotalPrice |currency:data?.SessionCurrency:'symbol'}}
        </span>
      </h5>
      <!-- total discount -->
      @if (hasDiscountPrice) {
        <h5
          class="fw-bold app-primary-color border-top-1 mt-3 mb-0 pt-3">
          <span class="" translate>Total Discount</span>:
          <!--            <i class="fa fa-percent pull-left" aria-hidden="true"></i>-->
          <span class="pull-right">{{data?.TotalDiscount |currency:data?.SessionCurrency:'symbol'}}</span>
        </h5>
      }
      <!-- total final prices -->
      @if (hasDiscountPrice) {
        <h5
          class="fw-bold app-primary-color border-top-1 mt-3 mb-0 pt-3">
          <span class="" translate>Total after discount</span>:
          <span class="pull-right">{{data?.TotalPrice - data?.TotalDiscount |currency:data?.SessionCurrency:'symbol'}}</span>
        </h5>
      }
      <!-- /total prices -->
    } @else {
      <p class="" translate>
        {{'sub_total_' + labelSuffix}}
        <span class="pull-right">
          <span>{{data?.TotalPriceAfterDiscount|currency:data?.SessionCurrency:'symbol'}}</span>
        </span>
      </p>
    }
  </div>
} @else {
  <contentloader [showTitle]="false"></contentloader>
}

<!-- contentloader -->
<!-- /contentloader -->

<!-- contentloader -->
<!-- /contentloader -->
